import { useContext } from "react"
import { EstabelecimentosAplicativoContext } from "./EstabelecimentosAplicativoContext"

export function useEstabelecimentosAplicativoContext() {
    return useContext(EstabelecimentosAplicativoContext)
}
